import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState, store} from "@/app/store";

export interface UnityBarState {
    bar: number,
}

const initialState: UnityBarState = {
    bar: 0,
}

export const unityBarSlice = createSlice({
    name: 'unityBar',
    initialState,
    reducers: {
        setUnityBar: (state, action: PayloadAction<UnityBarState['bar']>) => {
            state.bar = action.payload;
        },
    },
})

export const { setUnityBar } = unityBarSlice.actions;

export const unityBarValue = (state: RootState) => state.unityBar;

export default unityBarSlice.reducer;

// export const UpdateUnityBar = (val:any) => {
//     store.dispatch(updateUnityBar(val));
// }